import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogOut, LayoutDashboard, ShieldCheck } from "lucide-react";

export default function Header({ variant = "marketing" }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-white/80 backdrop-blur-xl border-b border-slate-200/70 shadow-sm"
    >
      <div className="max-w-7xl mx-auto px-6 py-3.5 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-3">
          <img src="/brand/besafe-logo.png" alt="Besafe Broker" className="h-10 sm:h-12 w-auto" />
          <div className="hidden md:block leading-tight border-l border-slate-200 pl-3">
            <div className="text-[10px] tracking-[0.22em] uppercase text-slate-500 font-semibold">Presenta</div>
            <div className="text-sm font-display text-[#0F7B85] font-semibold">un Amico</div>
          </div>
        </Link>

        <nav className="flex items-center gap-2 sm:gap-4">
          {variant === "marketing" && (
            <>
              <a href="#come-funziona" className="hidden sm:inline text-sm text-slate-600 hover:text-[#0F7B85] transition-colors">Come funziona</a>
              <a href="#regolamento" className="hidden sm:inline text-sm text-slate-600 hover:text-[#0F7B85] transition-colors">Regolamento</a>
              <a href="#faq" className="hidden sm:inline text-sm text-slate-600 hover:text-[#0F7B85] transition-colors">FAQ</a>
            </>
          )}
          {user && user.role ? (
            <>
              {user.role === "admin" ? (
                <Link
                  to="/admin"
                  data-testid="header-admin-link"
                  className="hidden sm:inline-flex items-center gap-1.5 text-sm text-[#0F7B85] font-medium"
                >
                  <ShieldCheck className="w-4 h-4" /> Admin
                </Link>
              ) : (
                <Link
                  to="/dashboard"
                  data-testid="header-dashboard-link"
                  className="hidden sm:inline-flex items-center gap-1.5 text-sm text-[#0F7B85] font-medium"
                >
                  <LayoutDashboard className="w-4 h-4" /> Area personale
                </Link>
              )}
              <button
                onClick={handleLogout}
                data-testid="header-logout-button"
                className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-[#F39C12] transition-colors"
              >
                <LogOut className="w-4 h-4" /> Esci
              </button>
            </>
          ) : (
            <>
              <a
                href="https://besafebroker.it"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="header-main-site-link"
                className="hidden sm:inline-flex text-sm text-slate-600 hover:text-[#0F7B85] px-3 py-2 transition-colors items-center gap-1"
                title="Sito istituzionale BeSafe Broker"
              >
                Sito ufficiale <span aria-hidden="true">↗</span>
              </a>
              <Link
                to="/login"
                data-testid="header-login-link"
                className="text-sm text-slate-700 hover:text-[#0F7B85] px-3 py-2 transition-colors"
              >
                Accedi
              </Link>
              <Link
                to="/registrati"
                data-testid="header-register-link"
                className="bg-[#0F7B85] text-white hover:bg-[#0A5C64] rounded-lg px-4 py-2 text-sm font-medium transition-colors"
              >
                Registrati
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
